// import { Heart, MoveLeft, MoveRight, Phone } from "lucide-react";
// import { images } from "../../assets/assets";
// import Navbar from "../../Components/Navbar";
// import { Link, useParams } from "react-router-dom";
// import Footer from "../../Components/Footer";
// import { getImageUrl } from "../../utils/getImageUrl";
// import { updateSEO } from "../../utils/seo";
// import { useState, useEffect } from "react";
// import { getServiceBySlug } from "../../api";

// const ServiceDetail = () => {
//   const { slug } = useParams();
//   const [serviceDetail, setServiceDetail] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchServiceDetail = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await getServiceBySlug(slug);
//         setServiceDetail(response?.data || null);
//       } catch (err) {
//         console.error("Error fetching service detail:", err);
//         setError("Failed to load service details. Please try again later.");
//         setServiceDetail(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (slug) {
//       fetchServiceDetail();
//     }
//   }, [slug]);

//   useEffect(() => {
//     if (serviceDetail) {
//       updateSEO({
//         title: serviceDetail.seoTitle || `${serviceDetail.name} | Dev Rishi Hospital`,
//         description: serviceDetail.metaDescription || serviceDetail.shortDesc,
//         keywords: serviceDetail.metaKeywords || ""
//       });
//     }
//   }, [serviceDetail]);

//   // Skeleton Loader Component
//   const SkeletonLoader = () => (
//     <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
//       <div className="w-full lg:w-[65%]">
//         {/* Overview Skeleton */}
//         <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4">
//           <div className="h-6 w-1/3 bg-gray-200 rounded animate-pulse mb-4"></div>
//           <div className="space-y-3">
//             <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//             <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//             <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
//           </div>
//         </div>

//         {/* Symptoms Skeleton */}
//         <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//           <div className="h-6 w-2/5 bg-gray-200 rounded animate-pulse mb-4"></div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
//             {[1, 2, 3, 4, 5, 6].map((idx) => (
//               <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//             ))}
//           </div>
//         </div>

//         {/* Services and Approach Skeleton */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//             <div className="h-6 w-1/2 bg-gray-200 rounded animate-pulse mb-4"></div>
//             <div className="space-y-3">
//               {[1, 2, 3].map((idx) => (
//                 <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//               ))}
//             </div>
//           </div>
//           <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//             <div className="h-6 w-2/5 bg-gray-200 rounded animate-pulse mb-4"></div>
//             <div className="space-y-3">
//               {[1, 2, 3].map((idx) => (
//                 <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Preventive Tips Skeleton */}
//         <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
//           <div className="h-6 w-1/3 bg-gray-200 rounded animate-pulse mb-4"></div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
//             {[1, 2, 3, 4, 5, 6].map((idx) => (
//               <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Doctor Detail Skeleton */}
//       <div className="w-full lg:w-auto lg:flex-1">
//         <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gray-200 rounded-[10px] animate-pulse"></div>
//         <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
//           <div className="h-10 w-full sm:w-auto bg-gray-200 rounded animate-pulse"></div>
//           <div className="h-12 w-full sm:w-auto bg-gray-200 rounded animate-pulse"></div>
//         </div>
//       </div>
//     </div>
//   );

//   // Placeholder Component for Missing Doctor Details
//   const DoctorPlaceholder = () => (
//     <div className="w-full lg:w-auto lg:flex-1">
//       <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gradient-to-br from-gray-100 to-gray-200 rounded-[10px] flex items-center justify-center border-2 border-dashed border-gray-300">
//         <div className="text-center">
//           <div className="w-24 h-24 mx-auto mb-4 bg-gray-300 rounded-full flex items-center justify-center">
//             <p className="text-4xl font-bold text-gray-500">N/A</p>
//           </div>
//           <p className="text-gray-600 font-semibold">Doctor Details Not Available</p>
//         </div>
//       </div>
//     </div>
//   );

//   // Default fallback data
//   const defaultServiceDetail = {
//     name: "Medicine Department",
//     shortDesc:
//       "Comprehensive medical care for general health conditions including diagnosis, treatment, and preventive healthcare. Our Medicine Department is equipped with advanced diagnostic tools and experienced physicians to ensure accurate and effective treatment.",
//     longDesc: [
//       "The Medicine Department at Dev Rishi Hospital is dedicated to providing comprehensive healthcare for a wide range of medical conditions. Our team of experienced physicians focuses on accurate diagnosis and effective treatment using advanced medical technology. We specialize in managing both acute illnesses and chronic diseases such as diabetes, hypertension, infections, and respiratory conditions.",
//       "Our approach emphasizes personalized care tailored to each patient’s health needs. We focus on early detection, preventive healthcare, and long-term disease management to ensure better outcomes. Patients receive continuous monitoring, lifestyle guidance, and follow-up care to maintain overall well-being.",
//       "We are equipped to handle both routine and emergency medical cases with efficiency and care. Our goal is to provide reliable, affordable, and patient-centered healthcare in a safe and comfortable environment. Dev Rishi Hospital is committed to improving the health and quality of life of every patient we serve.",
//     ],
//     doctorDetail: {
//       name: "Dr. Amit Sharma",
//       degree: "MBBS, MD (Cardiology)",
//       experience: "10+",
//       imagePath: ""
//     },
//     symptomHeading: "Common Symptoms of Heart Problems:",
//     symptoms: [
//       "Fever and infections",
//       "Fever and infections",
//       "High blood pressure",
//       "Blood sugar imbalance",
//       "Digestive problems",
//       "Respiratory issues (cough, breathlessness)",
//     ],
//     serviceOfferHeading: "Services We Offer:",
//     offeredServices: [
//       "Digestive problems",
//       "Diabetes Management",
//       "Hypertension Treatment",
//       "Infection & Fever Treatment",
//       "Infection & Fever Treatment",
//       "Preventive Health Care",
//     ],
//     approachHeading: "Our Approach to Heart Care:",
//     approaches: [
//       "Detailed Consultation",
//       "Diagnostic Testing",
//       "Accurate Diagnosis",
//       "Personalized Treatment Plan",
//       "Continuous Monitoring & Follow-up  ",
//     ],
//     preventiveTipHeading: "Preventive Heart Care Tips:",
//     preventiveTips: [
//       "Exercise regularly",
//       "Exercise regularly",
//       "Go for regular health checkups",
//       "Stay hydrated and manage stress",
//       "Monitor blood pressure and sugar levels",
//       "Maintain a balanced and healthy diet",
//     ],
//   };

//   const data = serviceDetail || defaultServiceDetail;

//   return (
//     <div className="font-lato">
//       <Navbar />

//       {/* Error State */}
//       {error && !loading && (
//         <div className="flex flex-col items-center justify-center py-16 px-4">
//           <div className="text-center max-w-[500px]">
//             <p className="text-3xl mb-4">⚠️</p>
//             <p className="text-lg font-semibold text-red-600 mb-2">Error Loading Service</p>
//             <p className="text-gray-600 mb-6">{error}</p>
//             <div className="flex gap-4 justify-center flex-wrap">
//               <button
//                 onClick={() => window.location.reload()}
//                 className="bg-[#1975FF] text-white px-6 py-2 rounded-[8px] hover:bg-[#1560d4] transition-colors duration-200"
//               >
//                 Try Again
//               </button>
//               <Link
//                 to="/services"
//                 className="border border-[#1975FF] text-[#1975FF] px-6 py-2 rounded-[8px] hover:bg-[#1975FF] hover:text-white transition-colors duration-200"
//               >
//                 Back to Services
//               </Link>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Loading State */}
//       {loading && (
//         <>
//           <div
//             className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
//             style={{
//               backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
// linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.ServiceDetailBanner})`,
//             }}
//           >
//             <Link
//               to="/services"
//               className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
//             >
//               <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" /> <span>Back to services</span>
//             </Link>
//             <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full">
//               <Heart color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
//             </div>
//             <div className="max-w-[680px] text-white text-center sm:text-left space-y-2">
//               <div className="h-8 w-48 bg-gray-400 rounded animate-pulse"></div>
//               <div className="h-4 w-96 bg-gray-400 rounded animate-pulse"></div>
//             </div>
//           </div>
//           <SkeletonLoader />
//         </>
//       )}

//       {/* Content State */}
//       {!loading && !error && (
//         <>
//           <div
//             className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
//             style={{
//               backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
// linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.ServiceDetailBanner})`,
//             }}
//           >
//             <Link
//               to="/services"
//               className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
//             >
//               <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" />{" "}
//               <span>Back to services</span>
//             </Link>
//             <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full hover:bg-[#E3A1A1] transition-all duration-300">
//               <Heart color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
//             </div>
//             <div className="max-w-[680px] text-white text-center sm:text-left">
//               <p className="text-[20px] sm:text-[26px] font-bold mt-2">
//                 {data?.name}
//               </p>
//               <p className="font-openSans text-[13px] sm:text-base leading-[1.4]">
//                 {data?.shortDesc}
//               </p>
//             </div>
//           </div>
//           {/* Detail */}
//           <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
//             <div className="w-full lg:w-[65%]">
//               {/* overview */}
//               <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//                 <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//                   Overview:
//                 </p>
//                 {data?.longDesc?.map((longdescription, idx) => (
//                   <p
//                     key={idx}
//                     className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-2"
//                   >
//                     {longdescription}
//                   </p>
//                 ))}
//               </div>
//               {/* symptom */}
//               <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//                 <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//                   {data?.symptomHeading}
//                 </p>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2">
//                   {data?.symptoms?.map((symptop, idx) => (
//                     <div
//                       key={idx}
//                       className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//                     >
//                       <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
//                       <p className="text-black font-openSans text-[13px] sm:text-base">
//                         {symptop}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               {/* service offer and approach */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
//                 <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//                   <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//                     {data?.serviceOfferHeading}
//                   </p>
//                   {data?.offeredServices?.map((service, idx) => (
//                     <div
//                       key={idx}
//                       className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//                     >
//                       <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
//                       <p className="text-black font-openSans text-[13px] sm:text-base">
//                         {service}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//                   <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//                     {data?.approachHeading}
//                   </p>
//                   {data?.approaches?.map((approach, idx) => (
//                     <div
//                       key={idx}
//                       className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer group"
//                     >
//                       <span className="text-[13px] sm:text-base font-semibold text-black group-hover:text-[#1975FF] mt-0.5">
//                         {idx + 1}.
//                       </span>
//                       <p className="text-black font-openSans text-[13px] sm:text-base">
//                         {approach}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               {/* preventive tips */}
//               <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
//                 <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
//                   {data?.preventiveTipHeading}
//                 </p>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2">
//                   {data?.preventiveTips?.map((preventiveTip, idx) => (
//                     <div
//                       key={idx}
//                       className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
//                     >
//                       <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
//                       <p className="text-black font-openSans text-[13px] sm:text-base">
//                         {preventiveTip}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             {/* doctor detail */}
//             {data?.doctorDetail && data?.doctorDetail?.name ? (
//               <div className="w-full lg:w-auto lg:flex-1">
//                 <div
//                   className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 hover:shadow-xl hover:-translate-y-1 rounded-[10px] overflow-hidden cursor-pointer"
//                   style={{
//                     backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(data?.doctorDetail?.imagePath)})`,
//                   }}
//                 >
//                   <div
//                     className="text-white text-base p-3 px-4 w-full transition-all duration-300 backdrop-blur-[6px]"
//                     style={{
//                       background:
//                         "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
//                     }}
//                   >
//                     <h3 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
//                       {data?.doctorDetail?.name}
//                     </h3>
//                     <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[16px]">
//                       {data?.doctorDetail?.degree}
//                     </p>
//                     <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[14px]">
//                       {data?.doctorDetail?.experience} Years
//                     </p>
//                   </div>
//                 </div>
//                 <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
//                   <Link
//                     to="/appointment"
//                     className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
//                   >
//                     Book Appointment{" "}
//                     <span className="p-2.5 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//                       <MoveRight
//                         color="#000"
//                         className="rotate-[-38deg] w-3.5 h-3.5 sm:w-5 sm:h-5"
//                       />
//                     </span>
//                   </Link>
//                   <Link
//                     to={`/doctor-detail/${data?.doctorDetail?.slug}`}
//                     className="rounded-[8px] sm:rounded-[10px] py-2.5 sm:py-3 px-[54px] text-[13px] sm:text-[14px] font-semibold text-[#1975FF] bg-white hover:bg-[#1975FF] hover:text-white hover:shadow-lg active:bg-[#1560d4] active:scale-95 active:shadow-md transition-all duration-200 border border-[#1975FF] text-center w-full sm:w-auto"
//                   >
//                     View Detail
//                   </Link>
//                 </div>
//               </div>
//             ) : (
//               <DoctorPlaceholder />
//             )}
//           </div>
//         </>
//       )}
//       {/*  Book Appointment  */}
//       <div className="py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-8 mb-14">
//         <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
//           Book Your Consultation
//         </h1>
//         <p className="max-w-[600px] font-openSans text-[14px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3">
//           Your heart deserves the best care. Don’t ignore early signs—consult
//           our specialists today for accurate diagnosis, personalized treatment,
//           and complete support throughout your journey to better health.
//         </p>
//         <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
//           <Link
//             to="/appointment"
//             className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
//           >
//             Book Appointment{" "}
//             <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//               <MoveRight
//                 color="#000"
//                 className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
//               />
//             </span>
//           </Link>
//           <a
//             href="tel:+917300906444"
//             className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
//           >
//             <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
//               <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
//             </span>
//             Call Now
//           </a>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default ServiceDetail;


import { Heart, MoveLeft, MoveRight, Phone } from "lucide-react";
import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import { Link, useParams } from "react-router-dom";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import SEOHead from "../../Components/SEOHead";
import { useState, useEffect, useContext } from "react";
import { getServiceBySlug } from "../../api";
import { InitialDataContext } from "../../context/InitialDataContext";

const ServiceDetail = () => {
  const { slug } = useParams();
  const ssrData = useContext(InitialDataContext);
  const [serviceDetail, setServiceDetail] = useState(ssrData?.data || null);
  const [loading, setLoading] = useState(!ssrData?.data);
  const [error, setError] = useState(null);

  useEffect(() => {
    // SSR ne pehle hi is slug ka data de diya hai, dubara fetch mat karo
    if (ssrData?.data && ssrData.data.slug === slug) {
      setServiceDetail(ssrData.data);
      setLoading(false);
      return;
    }

    const fetchServiceDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getServiceBySlug(slug);
        setServiceDetail(response?.data || null);
      } catch (err) {
        console.error("Error fetching service detail:", err);
        setError("Failed to load service details. Please try again later.");
        setServiceDetail(null);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchServiceDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
      <div className="w-full lg:w-[65%]">
        {/* Overview Skeleton */}
        <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4">
          <div className="h-6 w-1/3 bg-gray-200 rounded animate-pulse mb-4"></div>
          <div className="space-y-3">
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Symptoms Skeleton */}
        <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
          <div className="h-6 w-2/5 bg-gray-200 rounded animate-pulse mb-4"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6].map((idx) => (
              <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        </div>

        {/* Services and Approach Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
            <div className="h-6 w-1/2 bg-gray-200 rounded animate-pulse mb-4"></div>
            <div className="space-y-3">
              {[1, 2, 3].map((idx) => (
                <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
            <div className="h-6 w-2/5 bg-gray-200 rounded animate-pulse mb-4"></div>
            <div className="space-y-3">
              {[1, 2, 3].map((idx) => (
                <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>
        </div>

        {/* Preventive Tips Skeleton */}
        <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6">
          <div className="h-6 w-1/3 bg-gray-200 rounded animate-pulse mb-4"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6].map((idx) => (
              <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        </div>
      </div>

      {/* Doctor Detail Skeleton */}
      <div className="w-full lg:w-auto lg:flex-1">
        <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gray-200 rounded-[10px] animate-pulse"></div>
        <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
          <div className="h-10 w-full sm:w-auto bg-gray-200 rounded animate-pulse"></div>
          <div className="h-12 w-full sm:w-auto bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );

  // Placeholder Component for Missing Doctor Details
  const DoctorPlaceholder = () => (
    <div className="w-full lg:w-auto lg:flex-1">
      <div className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-gradient-to-br from-gray-100 to-gray-200 rounded-[10px] flex items-center justify-center border-2 border-dashed border-gray-300">
        <div className="text-center">
          <div className="w-24 h-24 mx-auto mb-4 bg-gray-300 rounded-full flex items-center justify-center">
            <p className="text-4xl font-bold text-gray-500">N/A</p>
          </div>
          <p className="text-gray-600 font-semibold">Doctor Details Not Available</p>
        </div>
      </div>
    </div>
  );

  // Default fallback data
  const defaultServiceDetail = {
    name: "Medicine Department",
    shortDesc:
      "Comprehensive medical care for general health conditions including diagnosis, treatment, and preventive healthcare. Our Medicine Department is equipped with advanced diagnostic tools and experienced physicians to ensure accurate and effective treatment.",
    longDesc: [
      "The Medicine Department at Dev Rishi Hospital is dedicated to providing comprehensive healthcare for a wide range of medical conditions. Our team of experienced physicians focuses on accurate diagnosis and effective treatment using advanced medical technology. We specialize in managing both acute illnesses and chronic diseases such as diabetes, hypertension, infections, and respiratory conditions.",
      "Our approach emphasizes personalized care tailored to each patient’s health needs. We focus on early detection, preventive healthcare, and long-term disease management to ensure better outcomes. Patients receive continuous monitoring, lifestyle guidance, and follow-up care to maintain overall well-being.",
      "We are equipped to handle both routine and emergency medical cases with efficiency and care. Our goal is to provide reliable, affordable, and patient-centered healthcare in a safe and comfortable environment. Dev Rishi Hospital is committed to improving the health and quality of life of every patient we serve.",
    ],
    doctorDetail: {
      name: "Dr. Amit Sharma",
      degree: "MBBS, MD (Cardiology)",
      experience: "10+",
      imagePath: ""
    },
    symptomHeading: "Common Symptoms of Heart Problems:",
    symptoms: [
      "Fever and infections",
      "Fever and infections",
      "High blood pressure",
      "Blood sugar imbalance",
      "Digestive problems",
      "Respiratory issues (cough, breathlessness)",
    ],
    serviceOfferHeading: "Services We Offer:",
    offeredServices: [
      "Digestive problems",
      "Diabetes Management",
      "Hypertension Treatment",
      "Infection & Fever Treatment",
      "Infection & Fever Treatment",
      "Preventive Health Care",
    ],
    approachHeading: "Our Approach to Heart Care:",
    approaches: [
      "Detailed Consultation",
      "Diagnostic Testing",
      "Accurate Diagnosis",
      "Personalized Treatment Plan",
      "Continuous Monitoring & Follow-up  ",
    ],
    preventiveTipHeading: "Preventive Heart Care Tips:",
    preventiveTips: [
      "Exercise regularly",
      "Exercise regularly",
      "Go for regular health checkups",
      "Stay hydrated and manage stress",
      "Monitor blood pressure and sugar levels",
      "Maintain a balanced and healthy diet",
    ],
  };

  const data = serviceDetail || defaultServiceDetail;

  return (
    <div className="font-lato">
      <SEOHead
        title={
          data?.seoTitle ||
          (data?.name ? `${data.name} | Dev Rishi Hospital` : undefined)
        }
        description={data?.metaDescription || data?.shortDesc}
        keywords={data?.metaKeywords}
        url={slug ? `https://devrishihospital.com/service-detail/${slug}` : undefined}
        schema={data?.name ? {
          "@context": "https://schema.org",
          "@type": "MedicalWebPage",
          "name": data.name,
          "description": data.shortDesc || data.metaDescription,
          "url": slug ? `https://devrishihospital.com/service-detail/${slug}` : undefined
        } : null}
      />
      <Navbar />

      {/* Error State */}
      {error && !loading && (
        <div className="flex flex-col items-center justify-center py-16 px-4">
          <div className="text-center max-w-[500px]">
            <p className="text-3xl mb-4">⚠️</p>
            <p className="text-lg font-semibold text-red-600 mb-2">Error Loading Service</p>
            <p className="text-gray-600 mb-6">{error}</p>
            <div className="flex gap-4 justify-center flex-wrap">
              <button
                onClick={() => window.location.reload()}
                className="bg-[#1975FF] text-white px-6 py-2 rounded-[8px] hover:bg-[#1560d4] transition-colors duration-200"
              >
                Try Again
              </button>
              <Link
                to="/services"
                className="border border-[#1975FF] text-[#1975FF] px-6 py-2 rounded-[8px] hover:bg-[#1975FF] hover:text-white transition-colors duration-200"
              >
                Back to Services
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <>
          <div
            className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.ServiceDetailBanner})`,
            }}
          >
            <Link
              to="/services"
              className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
            >
              <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" /> <span>Back to services</span>
            </Link>
            <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full">
              <Heart color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
            </div>
            <div className="max-w-[680px] text-white text-center sm:text-left space-y-2">
              <div className="h-8 w-48 bg-gray-400 rounded animate-pulse"></div>
              <div className="h-4 w-96 bg-gray-400 rounded animate-pulse"></div>
            </div>
          </div>
          <SkeletonLoader />
        </>
      )}

      {/* Content State */}
      {!loading && !error && (
        <>
          <div
            className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
linear-gradient(rgba(217,217,217,0.2), rgba(217,217,217,0.2)), url(${images.ServiceDetailBanner})`,
            }}
          >
            <Link
              to="/services"
              className="flex gap-2 items-center text-[13px] sm:text-base text-white hover:text-gray-300 hover:-translate-x-1 active:scale-95 transition-all duration-200 absolute top-4 sm:top-1/2 sm:-translate-y-1/2 left-4 sm:left-12"
            >
              <MoveLeft color="#fff" className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5" />{" "}
              <span>Back to services</span>
            </Link>
            <div className="p-3 sm:p-4 bg-[#E3A1A166] rounded-full hover:bg-[#E3A1A1] transition-all duration-300">
              <Heart color="#ffffff" className="w-8 h-8 sm:w-10 sm:h-10" />
            </div>
            <div className="max-w-[680px] text-white text-center sm:text-left">
              <p className="text-[20px] sm:text-[26px] font-bold mt-2">
                {data?.name}
              </p>
              <p className="font-openSans text-[13px] sm:text-base leading-[1.4]">
                {data?.shortDesc}
              </p>
            </div>
          </div>
          {/* Detail */}
          <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
            <div className="w-full lg:w-[65%]">
              {/* overview */}
              <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
                <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
                  Overview:
                </p>
                {Array.isArray(data?.longDesc) ? (
                  data.longDesc.map((longdescription, idx) => (
                    <p
                      key={idx}
                      className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-2"
                    >
                      {longdescription}
                    </p>
                  ))
                ) : (
                  <p className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-2">
                    {data?.longDesc || ""}
                  </p>
                )}
              </div>
              {/* symptom */}
              <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
                <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
                  {data?.symptomHeading}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2">
                  {Array.isArray(data?.symptoms) && data.symptoms.map((symptop, idx) => (
                    <div
                      key={idx}
                      className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                    >
                      <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
                      <p className="text-black font-openSans text-[13px] sm:text-base">
                        {symptop}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              {/* service offer and approach */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
                  <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
                    {data?.serviceOfferHeading}
                  </p>
                  {Array.isArray(data?.offeredServices) && data.offeredServices.map((service, idx) => (
                    <div
                      key={idx}
                      className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                    >
                      <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
                      <p className="text-black font-openSans text-[13px] sm:text-base">
                        {service}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
                  <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
                    {data?.approachHeading}
                  </p>
                  {Array.isArray(data?.approaches) && data.approaches.map((approach, idx) => (
                    <div
                      key={idx}
                      className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer group"
                    >
                      <span className="text-[13px] sm:text-base font-semibold text-black group-hover:text-[#1975FF] mt-0.5">
                        {idx + 1}.
                      </span>
                      <p className="text-black font-openSans text-[13px] sm:text-base">
                        {approach}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              {/* preventive tips */}
              <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
                <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
                  {data?.preventiveTipHeading}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2">
                  {Array.isArray(data?.preventiveTips) && data.preventiveTips.map((preventiveTip, idx) => (
                    <div
                      key={idx}
                      className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                    >
                      <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-1.5 flex-shrink-0"></span>
                      <p className="text-black font-openSans text-[13px] sm:text-base">
                        {preventiveTip}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* doctor detail */}
            {data?.doctorDetail && data?.doctorDetail?.name ? (
              <div className="w-full lg:w-auto lg:flex-1">
                <div
                  className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 hover:shadow-xl hover:-translate-y-1 rounded-[10px] overflow-hidden cursor-pointer"
                  style={{
                    backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(data?.doctorDetail?.imagePath)})`,
                  }}
                >
                  <div
                    className="text-white text-base p-3 px-4 w-full transition-all duration-300 backdrop-blur-[6px]"
                    style={{
                      background:
                        "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
                    }}
                  >
                    <h3 className="text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                      {data?.doctorDetail?.name}
                    </h3>
                    <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[16px]">
                      {data?.doctorDetail?.degree}
                    </p>
                    <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[14px]">
                      {data?.doctorDetail?.experience} Years
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
                  <Link
                    to="/appointment"
                    className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
                  >
                    Book Appointment{" "}
                    <span className="p-2.5 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
                      <MoveRight
                        color="#000"
                        className="rotate-[-38deg] w-3.5 h-3.5 sm:w-5 sm:h-5"
                      />
                    </span>
                  </Link>
                  <Link
                    to={`/doctor-detail/${data?.doctorDetail?.slug}`}
                    className="rounded-[8px] sm:rounded-[10px] py-2.5 sm:py-3 px-[54px] text-[13px] sm:text-[14px] font-semibold text-[#1975FF] bg-white hover:bg-[#1975FF] hover:text-white hover:shadow-lg active:bg-[#1560d4] active:scale-95 active:shadow-md transition-all duration-200 border border-[#1975FF] text-center w-full sm:w-auto"
                  >
                    View Detail
                  </Link>
                </div>
              </div>
            ) : (
              <DoctorPlaceholder />
            )}
          </div>
        </>
      )}
      {/*  Book Appointment  */}
      <div className="py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-8 mb-14">
        <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Book Your Consultation
        </h1>
        <p className="max-w-[600px] font-openSans text-[14px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3">
          Your heart deserves the best care. Don’t ignore early signs—consult
          our specialists today for accurate diagnosis, personalized treatment,
          and complete support throughout your journey to better health.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
              />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetail;